import type { PhoneData } from 'src/functions/formatPhone/types'

function formatPhoneByMask(phone: string, mask: string) {
  let phoneIndex = -1

  return mask.split('')
    .map(symbol => {
      if (symbol === 'X') {
        phoneIndex++
        return phone[phoneIndex]
      }

      return symbol
    }).join('')
}

export default function getFormattedPhone(phone: string, phoneData: PhoneData | null) {
  if (!phoneData) {
    return phone
  }

  const rawPhone = phone.replace(/[^()0-9,;/]/g, '')
    .split(/[,;/]/)
    .map(i => i
      .replace(/\(\d+\)$/g, '')
      .replace(/[^0-9]/g, ''))
    .sort((a, b) => a.length - b.length)
    .pop()!
    .slice(-phoneData.length)

  if (rawPhone.length !== phoneData.length) {
    return phone
  }

  const prefix = phoneData.getPrefix
    ? phoneData.getPrefix(rawPhone, phoneData.code)
    : phoneData.code

  return `${prefix} ${formatPhoneByMask(rawPhone, phoneData.mask)}`
}
